export default __webpack_public_path__ + "static/2203-4539f28216315bf59d062932cdb72aec.gif";